import { NavLink } from "react-router-dom";
import styles from "./equipe-card.module.css";

interface IProps {
  image: any;
  name: string;
  cargo: string;
  onHandlePages: any;
  url: string;
}

const EquipeCard = ({ image, name, cargo, onHandlePages, url }: IProps) => {
  return (
    <NavLink to={url} onClick={() => onHandlePages("EQUIPE")}>
      <div className={styles.equipe_card}>
        <div className={styles.equipe_img_div}>
          <img
            className={styles.equipe_img}
            src={image}
            alt="Imagem card."
            loading="lazy"
          />
        </div>
        <div className={styles.texts_div}>
          <span className={styles.equipe_nome}>{name}</span>
          <span className={styles.equipe_cargo}>{cargo}</span>
        </div>
      </div>
    </NavLink>
  );
};

export default EquipeCard;
